// extracted by mini-css-extract-plugin
export default {"navbarContainer":"Navbar_navbarContainer__ize-U","navbarLogo":"Navbar_navbarLogo__O2wwL","legal":"Navbar_legal__b7Lyr","link":"Navbar_link__srvb+"};